module.exports = __webpack_public_path__ + "static/media/cover2.6f6e7996.png";